<template lang="html">
  <v-content>
    <v-dialog
      v-model="documentLogTableDialogOpened"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="documentLogTableDialogOpened = false"
    >
      <v-card>
        <v-card-title class="title">
          {{ getTableTitle }} ({{ documentLogs.length }})
          <v-spacer />
          <v-btn
            small
            flat
            fab
            class="my-0 white error--text text-capitalize"
            @click="documentLogTableDialogOpened = false"
          >
            <v-icon size="24"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <document-table :documents="documentLogs" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="questionnairesTableDialogOpened"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="questionnairesTableDialogOpened = false"
    >
      <v-card v-if="selectedToDoItem">
        <v-card-title class="title pb-0">
          {{ getTableTitle }} ({{ questionnaires.length }})
          <v-spacer />
          <v-btn
            small
            flat
            fab
            class="my-0 white error--text text-capitalize"
            @click="questionnairesTableDialogOpened = false"
          >
            <v-icon size="24"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <questionnaires-table
            :questionnaires="questionnaires"
            :onlyUnstarted="selectedToDoItem.type_id === 1"
            @refresh-questionnaires="
              openQuestionnairesTableDialog(selectedToDoItem)
            "
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="messagesTableDialogOpened"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="messagesTableDialogOpened = false"
    >
      <v-card>
        <v-card-title class="title pb-0">
          {{ getTableTitle }} ({{ lastMessages.length }})
          <v-spacer />
          <v-btn
            small
            flat
            fab
            class="my-0 white error--text text-capitalize"
            @click="messagesTableDialogOpened = false"
          >
            <v-icon size="24"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="true"
            outline
            block
            :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
            color="primary"
            class="text-xs-left mx-2"
          >
            Please open conversation to send a message
          </v-alert>
          <message-table
            :messages="lastMessages"
            @open-specific-conversation="openSpecificConversation"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="questionnaireCommentsTableDialogOpened"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="questionnaireCommentsTableDialogOpened = false"
    >
      <v-card>
        <v-card-title class="title pt-4">
          {{ getTableTitle }} ({{ newQuestionnaireComments.length }})
          <v-spacer />
          <v-btn
            small
            flat
            fab
            class="my-0 white error--text text-capitalize"
            @click="questionnaireCommentsTableDialogOpened = false"
          >
            <v-icon size="24"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="true"
            outline
            block
            :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
            color="primary"
            class="text-xs-left mx-2"
          >
            Please click to open the questionnaire
          </v-alert>
          <questionnaire-comments-table :comments="newQuestionnaireComments" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container fluid style="max-width: 800px">
      <v-layout class="mb-4">
        <soraban-action-button
          @click="$router.go(-1)"
          icon="keyboard_arrow_left"
          help="Back"
        />
        <h1>Suggested Tasks</h1>
        <v-spacer />
        <soraban-action-button
          @click="refreshToDoList(true)"
          :disabled="refreshing"
          icon="refresh"
          :help="lastUpdatedTime"
          class="success--text"
        />
        <!-- <div v-if="viewAll" @click="viewAll = false" class="darkgrey--text mr-4" style="cursor: pointer"><v-icon color="darkgrey" size="18" class="mr-1">visibility</v-icon>View All</div>
        <div v-else @click="viewAll = true" class="darkgrey--text mr-4" style="cursor: pointer"><v-icon color="darkgrey" size="18" class="mr-1">visibility</v-icon>View My Tasks</div>
        <div class="darkgrey--text mr-2" style="cursor: pointer"><v-icon color="darkgrey" size="20" class="mr-1">sort</v-icon>Sort By</div> -->
        <!-- <soraban-action-button
          @click="openCreateTaskDialog()"
          icon="add"
          help="Create Task"
        /> -->
      </v-layout>
      <v-layout column align-center v-if="refreshing">
        <v-progress-circular
          indeterminate
          size="60"
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-flex
        class="text-xs-center subheading"
        v-else-if="isEmpty(undismissedToDoItems)"
      >
        <v-icon class="success--text mr-2">check</v-icon>
        <span
          >There are no suggested tasks at this time. Please try
          refreshing.</span
        >
      </v-flex>
      <v-layout column v-else align-center>
        <ToDoItemCard
          :to-do-item="toDoItem"
          v-for="toDoItem in undismissedToDoItems"
          :key="toDoItem.id"
          class="mb-2"
          :item-loading="itemLoading && selectedToDoItemId === toDoItem.id"
          @open-document-table-dialog="openDocumentLogTableDialog"
          @open-questionnaires-table-dialog="openQuestionnairesTableDialog"
          @open-questionnaire-comments-table-dialog="
            openQuestionnaireCommentsTableDialog
          "
          @open-messages-table-dialog="openMessagesTableDialog"
          @dismiss-to-do-item="dismissToDoItem"
        />
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import API from '@/api';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import ToDoItemCard from '@/components/ToDoItemCard';
import DocumentTable from '@/components/tables/DocumentTable';
import MessageTable from '@/components/tables/MessageTable';
import NotificationTable from '@/components/tables/NotificationTable';
import QuestionnairesTable from '@/components/tables/QuestionnairesTable';
import QuestionnaireCommentsTable from '@/components/tables/QuestionnaireCommentsTable';

export default {
  name: 'SuggestedTasks',
  components: {
    ToDoItemCard,
    DocumentTable,
    QuestionnairesTable,
    QuestionnaireCommentsTable,
    MessageTable,
    QuestionnairesTable,
  },
  data() {
    return {
      toDoItems: [],
      documentLogTableDialogOpened: false,
      questionnaireCommentsTableDialogOpened: false,
      questionnairesTableDialogOpened: false,
      messagesTableDialogOpened: false,
      documentLogs: [],
      questionnaires: [],
      selectedQuestionnaires: [],
      newQuestionnaireComments: [],
      lastMessages: [],
      refreshing: false,
      selectedToDoItem: null,
      itemLoading: false,
      selectedToDoItemTableTitles: [
        {
          type_id: 1,
          table_title: 'Questionnaires not yet started by client',
        },
        {
          type_id: 2,
          table_title: 'Questionnaires with no recent activities',
        },
        {
          type_id: 3,
          table_title: 'Questionnaires due soon',
        },
        {
          type_id: 4,
          table_title: 'New client notes left on questions',
        },
        {
          type_id: 5,
          table_title: 'Staff messages that require follow up',
        },
        {
          type_id: 6,
          table_title: 'Unanswered client messages',
        },
        {
          type_id: 7,
          table_title: 'Questionnaires past due',
        },
        {
          type_id: 8,
          table_title: 'Completed and unlocked questionnaires',
        },
      ],
    };
  },
  computed: {
    lastUpdatedTime() {
      if (!isEmpty(this.toDoItems)) {
        return `Refresh (${moment(this.toDoItems[0].created_at).format(
          'lll',
        )})`;
      } else {
        return 'Refresh';
      }
    },
    undismissedToDoItems() {
      return this.toDoItems.filter(d => !d.dismissed);
    },
    getTableTitle() {
      if (this.selectedToDoItem) {
        return this.selectedToDoItemTableTitles.find(
          a => a.type_id === this.selectedToDoItem.type_id,
        ).table_title;
      } else {
        return '';
      }
    },
    selectedToDoItemId() {
      if (this.selectedToDoItem) {
        return this.selectedToDoItem.id;
      } else {
        return null;
      }
    },
  },
  methods: {
    isEmpty,
    moment,
    async openDocumentLogTableDialog(ids) {
      const response = await API.advisor.getUploadedDocumentLogs({
        ids,
      });
      this.documentLogs = response.data.logs;
      this.documentLogTableDialogOpened = true;
    },
    openSpecificConversation(id) {
      this.$emit('openSpecificConversation', id);
    },
    async openQuestionnaireCommentsTableDialog(toDoItem) {
      this.itemLoading = true;
      this.selectedToDoItem = toDoItem;
      const response = await API.advisor.getComments({
        ids: toDoItem.related_ids,
      });
      this.newQuestionnaireComments = response.data.comments;
      this.questionnaireCommentsTableDialogOpened = true;
      this.itemLoading = false;
    },
    async openMessagesTableDialog(toDoItem) {
      this.itemLoading = true;
      this.selectedToDoItem = toDoItem;
      const response = await API.advisor.getMessages({
        ids: toDoItem.related_ids,
      });
      this.lastMessages = response.data.messages;
      this.messagesTableDialogOpened = true;
      this.itemLoading = false;
    },
    // async getReminderLogs() {
    //   const response = await API.advisor.getReminderLogs({
    //     timeRange: this.selectedFilter
    //   })
    //   this.reminderLogs = response.data.logs;
    // },
    async openQuestionnairesTableDialog(toDoItem) {
      this.selectedToDoItem = toDoItem;
      this.itemLoading = true;
      const response = await API.advisor.getQuestionnaires({
        ids: toDoItem.related_ids,
      });
      this.questionnaires = response.data.questionnaires;
      this.questionnairesTableDialogOpened = true;
      this.itemLoading = false;
    },
    dismissSelectedToDoItem() {
      if (this.selectedToDoItem && !this.selectedToDoItem.dismissed) {
        this.dismissSelectedToDoItem(this.selectedToDoItem);
        this.selectedToDoItem = null;
      }
    },
    async dismissToDoItem(toDoItem) {
      toDoItem.dismissed = true;
      const response = await API.advisor.dismissToDoItem(toDoItem.id);
    },
    async getStartedQuestionnaires() {
      const response = await API.advisor.getStartedQuestionnaires({
        timeRange: this.selectedFilter,
      });
      this.startedQuestionnaires = response.data.questionnaires;
    },
    async refreshToDoList(forceRefresh) {
      this.refreshing = true;
      try {
        const response = await API.advisor.getToDoList({
          reset: forceRefresh,
        });
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
          console.log(response.data.error);
        } else {
          this.toDoItems = response.data;
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.refreshing = false;
      }
    },
  },
  created() {
    this.refreshToDoList(false);
  },
};
</script>

<style lang="css"></style>
